import { useHistory, useLocation } from 'react-router-dom'
import BrandTab from 'src/components/admin-droplists/BrandTab'
import { ErrorText, InlineSpinner, Page, PageSubtitle, PageTitle, Tabs } from 'src/components/affiliate/ui'
import { useDroplistBrands } from 'src/hooks/useDroplists'
import { droplistError } from 'src/utils/droplistApi'

/** Run the droplist parsers, review what they found, then push to V3 / create the release. */
const AdminDroplistsPage = () => {
    const history = useHistory()
    const location = useLocation()
    const { data, isLoading, error } = useDroplistBrands()

    const brands = data?.brands ?? []
    const param = new URLSearchParams(location.search).get('brand')
    const current = brands.find((b) => b.id === param) ?? brands[0]

    const setBrand = (id: string) => {
        const params = new URLSearchParams(location.search)
        params.set('brand', id)
        history.replace({ pathname: location.pathname, search: `?${params.toString()}` })
    }

    return (
        <Page>
            <div>
                <PageTitle>Droplists</PageTitle>
                <PageSubtitle>Parse this week&apos;s drops, review the products, then push them to V3.</PageSubtitle>
            </div>
            {isLoading ? (
                <InlineSpinner />
            ) : error ? (
                <ErrorText>{droplistError(error)}</ErrorText>
            ) : (
                <>
                    {current && (
                        <>
                            <Tabs<string>
                                tabs={brands.map((b) => ({
                                    value: b.id,
                                    label: b.run?.busy ? `${b.name} …` : b.name,
                                }))}
                                value={current.id}
                                onChange={setBrand}
                            />
                            <BrandTab key={current.id} brand={current} />
                        </>
                    )}
                </>
            )}
        </Page>
    )
}

export default AdminDroplistsPage
